import Konva from "konva";
import { useState, useEffect, memo, ImgHTMLAttributes } from "react";

export function Thumbnail(props: ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <img
      {...props}
      key={props.src}
      style={{ width: "60px", height: "60px", objectFit: "contain", objectPosition: "center" }}
    />
  );
}

export const ElementThumbnail = memo(({ konvaLayer, objId }: { konvaLayer?: Konva.Layer | null; objId: string }) => {
  const [thumb, setThumb] = useState("");

  useEffect(() => {
    if (konvaLayer) {
      setThumb(konvaLayer.findOne(`.${objId}`)?.toDataURL() || "");
    }
  }, [objId, konvaLayer]);

  return <Thumbnail src={thumb} />;
});

ElementThumbnail.displayName = "ElementThumbnail";
